import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(detail) {
  if (detail == null) return "Errore imprevisto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMsg(e) {
  return apiError(e?.response?.data?.detail) || e?.message || "Errore";
}

export const STATUSES = ["PRESENTE", "ASSENTE", "FERIE", "MALATTIA", "INFORTUNIO", "PERMESSO", "RIPOSO"];

export const TYPE_LABELS = {
  FERIE: "Ferie",
  RIPOSO: "Riposo",
  PERMESSO: "Permesso (1 giorno)",
  PERMESSO_104: "Permesso 104",
  MALATTIA: "Malattia (senza certificato)",
  INFORTUNIO: "Infortunio",
};

export const STATUS_META = {
  PRESENTE: { short: "PR", cell: "bg-emerald-100 text-emerald-900 dark:bg-emerald-950 dark:text-emerald-300", dot: "bg-emerald-500" },
  ASSENTE: { short: "AS", cell: "bg-rose-100 text-rose-900 dark:bg-rose-950 dark:text-rose-300", dot: "bg-rose-500" },
  FERIE: { short: "FE", cell: "bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-300", dot: "bg-amber-500" },
  MALATTIA: { short: "MA", cell: "bg-purple-100 text-purple-900 dark:bg-purple-950 dark:text-purple-300", dot: "bg-purple-500" },
  INFORTUNIO: { short: "IN", cell: "bg-orange-100 text-orange-900 dark:bg-orange-950 dark:text-orange-300", dot: "bg-orange-500" },
  PERMESSO: { short: "PE", cell: "bg-sky-100 text-sky-900 dark:bg-sky-950 dark:text-sky-300", dot: "bg-sky-500" },
  RIPOSO: { short: "RI", cell: "bg-slate-200 text-slate-700 dark:bg-slate-800 dark:text-slate-300", dot: "bg-slate-400" },
};

export const MONTHS_IT = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

export const DOW_IT = ["D", "L", "M", "M", "G", "V", "S"];

export function pad(n) { return String(n).padStart(2, "0"); }

/** Qualsiasi data (ISO, con o senza ora) mostrata come GG/MM/AAAA. */
export function itDate(v, withTime = false) {
  if (!v) return "";
  const s = String(v);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const base = `${m[3]}/${m[2]}/${m[1]}`;
    if (!withTime) return base;
    const t = s.match(/[T ](\d{2}):(\d{2})/);
    return t ? `${base} ${t[1]}:${t[2]}` : base;
  }
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return withTime
    ? d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export async function download(path, filename) {
  const isPdf = /\.pdf$/i.test(filename || "");
  // su mobile il blob in nuova scheda o in iframe resta bianco (iOS Safari): si apre
  // direttamente l'URL del server, così il telefono usa il suo visualizzatore PDF
  // e l'utente decide se stampare, salvare o condividere
  if (isPdf && window.innerWidth < 768) {
    window.location.assign(`${api.defaults.baseURL}${path}`);
    return;
  }
  const res = await api.get(path, { responseType: "blob" });
  const blob = new Blob([res.data], isPdf ? { type: "application/pdf" } : {});
  const url = window.URL.createObjectURL(blob);
  if (isPdf) {
    // anteprima in una nuova scheda: l'utente decide se stampare, salvare o scaricare
    const w = window.open(url, "_blank");
    if (!w) window.dispatchEvent(new CustomEvent("app:open-pdf", { detail: { url, filename } }));
    else setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    return;
  }
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
